import React, { forwardRef, useImperativeHandle } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { Col, Form, Row } from 'reactstrap';
import OInput from '../../../Components/OElements/OInput';
import OSelect from '../../../Components/OElements/OSelect';
import { DateInput } from '@mantine/dates';
import { getProcedureTypeListQuery } from '../../../slices/thunks';

const ProcedureHistoryForm = forwardRef(({ onSubmit, dataToEdit, waterRightId }, ref) => {
	const dispatch = useDispatch();

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataToEdit?.name || '',
			water_right_id: waterRightId || dataToEdit?.water_right_id || '',
			procedure_type_id: dataToEdit?.procedure_type?._id || dataToEdit?.procedure_type_id || '',
			procedure_date: dataToEdit?.procedure_date || '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('El nombre es requerido'),
			procedure_type_id: Yup.string().required('El tipo de trámite es requerido'),
			procedure_date: Yup.date().required('La fecha del trámite es requerida'),
		}),
		onSubmit: values => {
			onSubmit(values);
		},
	});

	// Expose handleSubmit to parent via ref
	useImperativeHandle(ref, () => ({
		handleSubmit: () => {
			validation.handleSubmit();
		},
	}));

	return (
		<Form
			onSubmit={e => {
				e.preventDefault();
				validation.handleSubmit();
				return false;
			}}
		>
			<Row>
				{/* Hidden field for water_right_id */}
				<input
					type="hidden"
					name="water_right_id"
					value={validation.values.water_right_id}
				/>

				<Col lg={12} className='mb-3'>
					<OInput
						label="Nombre"
						name="name"
						type="text"
						placeholder="Ingrese el nombre del trámite"
						validation={validation}
						isRequired={true}
					/>
				</Col>

				<Col lg={12} className='mb-3'>
					<OSelect
						label="Tipo de Trámite"
						name="procedure_type_id"
						value={validation.values.procedure_type_id || ''}
						requestApi={async () => {
							const result = await dispatch(getProcedureTypeListQuery({
								filters: { disable: { $eq: false } },
								page: 1,
								limit: 1000,
							})).unwrap();
							return result.data || [];
						}}
						validation={validation}
						isRequired={true}
					/>
				</Col>

				<Col lg={12} className='mb-3'>
					<div className="mb-3">
						<label htmlFor="procedure_date" className="form-label">
							Fecha del Trámite <span className="text-danger">*</span>
						</label>
						<DateInput
							id="procedure_date"
							name="procedure_date"
							placeholder="Seleccione la fecha"
							value={validation.values.procedure_date ? new Date(validation.values.procedure_date) : null}
							onChange={(date) => validation.setFieldValue('procedure_date', date)}
							onBlur={() => validation.setFieldTouched('procedure_date', true)}
							error={
								validation.touched.procedure_date && validation.errors.procedure_date
									? validation.errors.procedure_date
									: null
							}
							clearable
						/>
					</div>
				</Col>
			</Row>
		</Form>
	);
});

ProcedureHistoryForm.displayName = 'ProcedureHistoryForm';

export default ProcedureHistoryForm;
